<template>
    <div class="android_setting_base">
        <span>システムアップデート（Android OSのアップデート）に関する設定を行ってください。</span>
        <div class="android_setting_main">
            <div>
                <label class="scv-check-label-box">
                    <input type="radio"
                           v-bind:disabled="disabled"
                           name="rdo_systemUpdateType"
                           v-model="rdobtn_systemUpdateType"
                           @change="onChangeSystemUpdateType"
                           :value="0">
                    <span>30日経過後にアップデートする</span>
                </label>
            </div>
            <div>
                <label class="scv-check-label-box">
                    <input type="radio"
                           v-bind:disabled="disabled"
                           name="rdo_systemUpdateType"
                           v-model="rdobtn_systemUpdateType"
                           @change="onChangeSystemUpdateType"
                           :value="1">
                    <span>自動的にアップデートする</span>
                </label>
            </div>
            <div class="android_setting_sub_btn">
                <div class="d-flex flex-row">
                    <div class="d-flex align-items-center" style="height:32px">
                        <input type="checkbox"
                               id="chk_systemUpdateTime"
                               v-bind:disabled="disabled || !(1 == rdobtn_systemUpdateType)"
                               v-model="chkbtn_systemUpdateTime"
                               @change="onChangeSystemUpdateType" />
                        <div>
                            <label class="scv-check-label" for="chk_systemUpdateTime">適用開始時間を指定する：</label>
                        </div>
                    </div>
                    <div>
                        <input type="time"
                               class="input-text-scv condition-text android_setting_item_time"
                               v-bind:class="{ 'input-validation-error': errorSystemUpdateTime != '' }"
                               v-bind:disabled="disabled || !(1 == rdobtn_systemUpdateType) || !chkbtn_systemUpdateTime"
                               v-model="time_systemUpdateStartTime"
                               @change="onChangeSystemUpdateStartTime" />
                        <span style="margin-left:8px; margin-right:8px;">～</span>
                        <input type="time"
                               class="input-text-scv condition-text android_setting_item_time"
                               v-bind:class="{ 'input-validation-error': errorSystemUpdateTime != '' }"
                               v-bind:disabled="disabled || !(1 == rdobtn_systemUpdateType) || !chkbtn_systemUpdateTime"
                               v-model="time_systemUpdateEndTime"
                               @change="onChangeSystemUpdateEndTime" />
                        <div class="modal-body-input-error-area-scv">
                            <div style="height: 4px"></div>
                            <span class="scv-form-validation-error">{{ errorSystemUpdateTime }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="d-flex flex-row">
                    <input type="checkbox"
                           id="chk_systemUpdateFreeze"
                           v-bind:disabled="disabled"
                           v-model="chkbtn_systemUpdateFreezePeriods"
                           @change="onChangeSystemUpdateFreezePeriods" />
                    <label for="chk_systemUpdateFreeze" class="scv-check-label">システムアップデートの実行を停止する期間を設定する</label>
                    <div class="d-flex align-items-end android_setting_item_info_panel">
                        <InformationManual :arMessage="['実行停止期間を複数設定する場合は、61日以上間隔を開ける必要があります。']" />
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column">
                <ListTitleBar :titleCaption="'システムアップデートの実行停止期間'"
                              :btnCaption_1="'追加'"
                              :btnCaption_2="'編集'"
                              :btnCaption_3="'削除'"
                              :btnActiveType_1="0"
                              :btnActiveType_2="1"
                              :btnActiveType_3="3"
                              :rowCountArea="true"
                              :rowCount="freezePeriodsSettings.length"
                              @onBtnClicked_1="onBtnAddFreezePeriods"
                              @onBtnClicked_2="onBtnEdtFreezePeriods"
                              @onBtnClicked_3="onBtnDelFreezePeriods"
                              :selectCount="getSelectCount()"
                              :disabled="disabled || !chkbtn_systemUpdateFreezePeriods">
                </ListTitleBar>
                <ListCtrl ref="freezePeriodsList"
                          :columns="freezePeriodsColumns"
                          :selectType="1"
                          :getCellTextFunc="getCellText"
                          style="min-height: 240px;"
                          :disabled="disabled || !chkbtn_systemUpdateFreezePeriods">
                </ListCtrl>
            </div>

        </div>
    </div>

    <!-- 追加画面 -->
    <div class="modal fade" id="modalFreezePeriods" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scv" role="document">
            <div class="modal-content modal-content-scv" style="position: relative; max-height:none; width: 650px;">
                <div class="modal-header modal-header-scv-cmn">
                    <div class="modal-header-text-box-scv" style="width: 100%">
                        <span class="modal-header-text-scv">{{modalCaption}}</span>
                    </div>
                    <div class="btn-scv-close">
                        <a class="btn-scv-close" role="button" data-bs-dismiss="modal">
                            <div class="icon-font-slategray">
                                <i class="icon-delete"></i>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="modal-body modal-body-scv">
                    <div class="android_modal_base">
                        <div class="d-flex flex-row">
                            <span>システムアップデートの実行を停止する期間を指定してください。</span>
                            <div class="d-flex align-items-end android_setting_item_info_panel">
                                <InformationManual :arMessage="['うるう日（2/29）は開始日・終了日に指定できません。<br />2/29を含む期間を設定した場合は、2/29もシステムアップデートが停止されます。']" />
                            </div>
                        </div>
                        <div class="android_modal_main">
                            <div class="d-flex flex-row">
                                <div class="box-item-title d-flex align-items-center" style="height:32px">
                                    <span>除外期間：</span>
                                </div>
                                <div class="d-flex flex-column" style="width:85%">
                                    <div class="d-flex flex-row align-items-center">
                                        <div class="select-icon">
                                            <select class="input-text-scv over-text"
                                                    v-model="modalFreezePeriodsSetting.startMonth"
                                                    style="min-width: 80px"
                                                    @change="onChangeModalStartMonth">
                                                <option v-for="item in freezePeriodsMonthSelectList" :value="item.id" :key="item.id">{{item.label}}</option>
                                            </select>
                                        </div>
                                        <div class="select-icon" style="margin-left: 8px">
                                            <select class="input-text-scv over-text"
                                                    v-model="modalFreezePeriodsSetting.startDay"
                                                    style="min-width: 80px">
                                                <option v-for="item in freezePeriodsStartDaySelectList" :value="item.id" :key="item.id">{{item.label}}</option>
                                            </select>
                                        </div>
                                        <div style="margin-left: 9px">
                                            <span>～</span>
                                        </div>
                                        <div class="select-icon" style="margin-left: 9px">
                                            <select class="input-text-scv over-text"
                                                    v-model="modalFreezePeriodsSetting.endMonth"
                                                    style="min-width: 80px"
                                                    @change="onChangeModalEndMonth">
                                                <option v-for="item in freezePeriodsMonthSelectList" :value="item.id" :key="item.id">{{item.label}}</option>
                                            </select>
                                        </div>
                                        <div class="select-icon" style="margin-left: 8px">
                                            <select class="input-text-scv over-text"
                                                    v-model="modalFreezePeriodsSetting.endDay"
                                                    style="min-width: 80px">
                                                <option v-for="item in freezePeriodsEndDaySelectList" :value="item.id" :key="item.id">{{item.label}}</option>
                                            </select>
                                        </div>
                                        <div style="margin-left: 8px">
                                            <span>（最長90日まで）</span>
                                        </div>
                                    </div>
                                    <div class="modal-body-input-error-area-scv">
                                        <div style="height: 4px"></div>
                                        <span class="scv-form-validation-error">{{ errorMessageEditFreezePeriods }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer modal-footer-scv">
                    <div class="d-flex justify-content-center">
                        <div zero-font>
                            <button type="button" class="btn-scv-blue" id="buttonApply_modalFreezePeriods" @click="onModalFreezePeriodsOKButton" style="margin-right: 40px;">OK</button>
                            <button type="button" class="btn-scv-white" data-bs-dismiss="modal">キャンセル</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import { AndroidPolicyWrapper } from '@/models/Mobile/Android/AndroidPolicyWrapper'
    import { ListCtrl } from 'lib-vue-v2/components';
    import ListTitleBar from '@/components/ListTitleBar.vue';
    import { SearchColumnData, SearchColumnType } from '@/models/SearchColumnData';
    import $ from "jquery";
    import MaskInput from '@/components/Input/MaskInput.vue';
    import { SelectBoxItemData } from "@/models/SelectBoxItemData"
    import { cloneDeep, toInteger } from 'lodash';
    import { AMAPI_Date, AMAPI_FreezePeriod, AMAPI_SystemUpdate } from '@/models/Mobile/Android/AndroidManagementV1Schema';
    import InformationManual from '@/components/InformationManual.vue';
    import { MessageUtil } from '@/models/Message/MessageUtil';
    import { BootstrapUtil } from 'lib-vue-v2/util';

    // 
    class AndroidFreezePeriodsSetting {
        startMonth = 1;   // 追加画面：開始月
        startDay = 1;     // 追加画面：開始日
        endMonth = 1;     // 追加画面：終了月
        endDay = 31;      // 追加画面：終了日
    }

    @Options({
        props: {
            disabled: { type: Boolean, Default: false },   /* 強制的にボタンをDisableにする*/
        },
        components: {
            ListCtrl,
            ListTitleBar,
            MaskInput,
            InformationManual,
        },
        watch: {
            freezePeriodsSettings: {
                handler: function () {
                    /* eslint @typescript-eslint/no-explicit-any: 0 */
                    const refObj: any = this.$refs;
                    refObj.freezePeriodsList.updateList(this.freezePeriodsSettings.length);
                },
                deep: true,   // オブジェクトの監視
                immediate: false
            }
        },
        emits: ['notifyUpdate'],
    })

    export default class AndroidOSSetting extends Vue {

        private policyRef = new AndroidPolicyWrapper();

        private readonly def_POSTPONE = "POSTPONE";
        private readonly def_AUTOMATIC = "AUTOMATIC";
        private readonly def_WINDOWED = "WINDOWED";

        private readonly def_freezePeriodsMax = 99;

        // カラム
        private readonly freezePeriodsColumns: Array<SearchColumnData> =
            [
                { columnID: 0, dataType: SearchColumnType.string, text: "期間" },
            ];

        private readonly freezePeriodsMonthSelectList: Array<SelectBoxItemData> =
            [
                { id: "1", label: "1月" },
                { id: "2", label: "2月" },
                { id: "3", label: "3月" },
                { id: "4", label: "4月" },
                { id: "5", label: "5月" },
                { id: "6", label: "6月" },
                { id: "7", label: "7月" },
                { id: "8", label: "8月" },
                { id: "9", label: "9月" },
                { id: "10", label: "10月" },
                { id: "11", label: "11月" },
                { id: "12", label: "12月" },
            ];
        private freezePeriodsStartDaySelectList = new Array<SelectBoxItemData>();
        private freezePeriodsEndDaySelectList = new Array<SelectBoxItemData>();

        private rdobtn_systemUpdateType = 0;
        private chkbtn_systemUpdateTime = false;
        private time_systemUpdateStartTime = "00:00";
        private time_systemUpdateEndTime = "23:59";
        private errorSystemUpdateTime = "";
        private chkbtn_systemUpdateFreezePeriods = false;
        private freezePeriodsSettings = new Array<AndroidFreezePeriodsSetting>();

        // モーダル用
        private modalAddMode = true;
        private modalCaption = "追加";
        private modalFreezePeriodsSetting = new AndroidFreezePeriodsSetting();
        private errorMessageEditFreezePeriods = "";

        /**
         *  UIのリセット
         */
        private resetUI() {
            this.rdobtn_systemUpdateType = 0;
            this.chkbtn_systemUpdateTime = false;
            this.time_systemUpdateStartTime = "00:00";
            this.time_systemUpdateEndTime = "23:59";
            this.chkbtn_systemUpdateFreezePeriods = false;
            this.freezePeriodsSettings = new Array<AndroidFreezePeriodsSetting>();
        }

        /**
         *  ポリシーの参照をセット
         */
        public setPolicyRef(policy: AndroidPolicyWrapper): void {
            this.policyRef = policy;

            // 初期化
            this.resetUI();

            if (undefined == this.policyRef.policy.systemUpdate) {
                let newData = new AMAPI_SystemUpdate();
                this.policyRef.policy.systemUpdate = newData;

                // デフォルトが設定されているので設定が無ければ設定しておく
                this.policyRef.policy.systemUpdate.type = this.def_POSTPONE;
                return;
            }
            else {
                // policyからUIを設定する
                this.updateSystemUpdateType();
                this.updateSystemUpdateFreezePeriods();
            }
        }

        /**
         *  OKボタン押下時のチェック処理
         */
        public isApply(): boolean {

            // エラーメッセージ
            this.errorSystemUpdateTime = "";

            if (undefined == this.policyRef.policy.systemUpdate) {
                return false;
            }

            // 適用開始時間を指定する場合
            if (this.def_WINDOWED == this.policyRef.policy.systemUpdate.type) {

                if (undefined == this.policyRef.policy.systemUpdate.endMinutes ||
                    undefined == this.policyRef.policy.systemUpdate.startMinutes) {
                    return false;
                }

                // 時間の差を計算
                let difMinute = 0;
                if (this.policyRef.policy.systemUpdate.startMinutes == this.policyRef.policy.systemUpdate.endMinutes) {
                    // 同一の時刻なら24時間を含む扱い
                    return true;
                }
                else if (this.policyRef.policy.systemUpdate.startMinutes < this.policyRef.policy.systemUpdate.endMinutes) {
                    difMinute = this.policyRef.policy.systemUpdate.endMinutes - this.policyRef.policy.systemUpdate.startMinutes;
                }
                else {
                    // 1440 = 24時00分
                    difMinute = (1440 + this.policyRef.policy.systemUpdate.endMinutes) - this.policyRef.policy.systemUpdate.startMinutes;
                }
                
                // 差が30分未満ならアウト
                if (difMinute < 30) {
                    this.errorSystemUpdateTime = "30分以上の期間を指定してください。";
                    return false;
                }
            }

            return true;
        }

        /*
         * 選択状態の数を返します
         */
        private getSelectCount(): number {
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;

            // マウント前はundefinedの可能性があるのでundefinedチェックが必要
            if (undefined == refObj.freezePeriodsList) {
                return 0;
            }
            return refObj.freezePeriodsList.getSelectListIndex().length;
        }

        /**
        * リスト作成処理
        */
        private getCellText(columnId: number, index: number): string {

            if (this.freezePeriodsSettings.length <= index) {
                return "";
            }

            switch (columnId) {
                // 期間
                case 0:
                    return this.freezePeriodsSettings[index].startMonth.toString() + "/" + this.freezePeriodsSettings[index].startDay.toString() +
                        "～" +
                        this.freezePeriodsSettings[index].endMonth.toString() + "/" + this.freezePeriodsSettings[index].endDay.toString();
            }
            return "";
        }

        /**
         *  変更ハンドラ
         */
        public onChange(): void {
            this.$emit('notifyUpdate');
        }

        /**
         *  システムアップデートの実行を制御する
         */
        private onChangeSystemUpdateType(): void {

            if (undefined == this.policyRef.policy.systemUpdate) {
                return;
            }

            // 使用する場合のみ下の条件で設定する
            this.policyRef.policy.systemUpdate.type = this.def_POSTPONE;
            this.policyRef.policy.systemUpdate.startMinutes = null;
            this.policyRef.policy.systemUpdate.endMinutes = null;

            // 適用を制御する
            if (0 == this.rdobtn_systemUpdateType) {
                // 可能になってから30日経過後にアップデートする
                this.policyRef.policy.systemUpdate.type = this.def_POSTPONE;
            }
            else {
                // 可能になったら自動的にアップデートする
                this.policyRef.policy.systemUpdate.type = this.def_AUTOMATIC;
                if (this.chkbtn_systemUpdateTime) {
                    // 適用時間を設定する(０時から分単位で計算)
                    this.policyRef.policy.systemUpdate.type = this.def_WINDOWED;
                    this.policyRef.policy.systemUpdate.startMinutes = this.getSystemUpdateMinute(this.time_systemUpdateStartTime);
                    this.policyRef.policy.systemUpdate.endMinutes = this.getSystemUpdateMinute(this.time_systemUpdateEndTime);
                }
            }

            this.onChange();
        }
        private onChangeSystemUpdateStartTime(): void {

            if (undefined == this.policyRef.policy.systemUpdate) {
                return;
            }
            this.policyRef.policy.systemUpdate.startMinutes = this.getSystemUpdateMinute(this.time_systemUpdateStartTime);

            this.onChange();
        }
        private onChangeSystemUpdateEndTime(): void {

            if (undefined == this.policyRef.policy.systemUpdate) {
                return;
            }
            this.policyRef.policy.systemUpdate.endMinutes = this.getSystemUpdateMinute(this.time_systemUpdateEndTime);

            this.onChange();
        }
        private updateSystemUpdateType(): void {

            if (undefined == this.policyRef.policy.systemUpdate) {
                return;
            }

            // UIが初期値から変わるときのみ設定
            if (null != this.policyRef.policy.systemUpdate.type) {
                if (this.def_AUTOMATIC == this.policyRef.policy.systemUpdate.type) {
                    this.rdobtn_systemUpdateType = 1;

                }
                else if (this.def_WINDOWED == this.policyRef.policy.systemUpdate.type) {
                    this.rdobtn_systemUpdateType = 1;
                    this.chkbtn_systemUpdateTime = true;
                    if (undefined != this.policyRef.policy.systemUpdate.startMinutes) {
                        this.time_systemUpdateStartTime = this.getSystemUpdateString(this.policyRef.policy.systemUpdate.startMinutes);
                    }
                    if (undefined != this.policyRef.policy.systemUpdate.endMinutes) {
                        this.time_systemUpdateEndTime = this.getSystemUpdateString(this.policyRef.policy.systemUpdate.endMinutes);
                    }
                }
            }
        }

        private getSystemUpdateMinute(time: string): number {

            let timeSplit = time.split(":");
            if (timeSplit.length < 2) {
                return 0;
            }

            let minute = toInteger(timeSplit[0]) * 60;
            minute += toInteger(timeSplit[1]);

            return minute;
        }

        private getSystemUpdateString(minute: number): string {

            let hours = Math.floor(minute / 60);
            let min = minute % 60;

            return ('0' + hours).slice(-2) + ':' + ('0' + min).slice(-2);
        }

        /**
         *  システムアップデートの適用を停止する期間を設定する
         */
        private onChangeSystemUpdateFreezePeriods(): void {

            if (undefined == this.policyRef.policy.systemUpdate) {
                return;
            }

            if (this.chkbtn_systemUpdateFreezePeriods) {
                this.onChangeFreezePeriodsSettings();
            }
            else {
                let freezePeriods = new Array<AMAPI_FreezePeriod>();
                this.policyRef.policy.systemUpdate.freezePeriods = freezePeriods;
                this.onChange();
            }
        }

        /**
         * @brief	追加ボタン
         */
        private onBtnAddFreezePeriods(): void {

            if (this.def_freezePeriodsMax <= this.freezePeriodsSettings.length) {
                let message = "これ以上登録することはできません。\r\n<br>システムアップデートの実行停止期間の登録上限は" + this.def_freezePeriodsMax.toString() + "件です。";
                MessageUtil.MessageBox(message, null, null, MessageUtil.MB_ICON_WARNING);
                return;
            }

            this.errorMessageEditFreezePeriods = "";

            this.modalAddMode = true;
            this.modalCaption = "追加";

            // デフォルトの日付は今日から９０日後
            // 年を前後に跨いでもうるう年にならない年
            this.modalFreezePeriodsSetting = new AndroidFreezePeriodsSetting();
            let endDate = new Date();
            if (2 == endDate.getMonth() &&
                29 == endDate.getDate()) {
                endDate.setDate(28);
            }
            endDate.setFullYear(2002);
            let startDate = new Date(endDate);
            endDate.setDate(endDate.getDate() + (90 - 1)); // 初日を数える
            this.modalFreezePeriodsSetting.startMonth = startDate.getMonth() + 1;
            this.modalFreezePeriodsSetting.startDay = startDate.getDate();
            this.modalFreezePeriodsSetting.endMonth = endDate.getMonth() + 1;
            this.modalFreezePeriodsSetting.endDay = endDate.getDate();



            this.freezePeriodsStartDaySelectList = this.createDaySelectList(this.modalFreezePeriodsSetting.startMonth);
            this.freezePeriodsEndDaySelectList = this.createDaySelectList(this.modalFreezePeriodsSetting.endMonth);

            BootstrapUtil.showModal('modalFreezePeriods');
        }

        /**
         * @brief	編集ボタン
         */
        private onBtnEdtFreezePeriods(): void {
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;
            const indexs = refObj.freezePeriodsList.getSelectListIndex();
            if (1 != indexs.length) {
                return;
            }

            this.errorMessageEditFreezePeriods = "";

            // 編集データのセット
            this.modalAddMode = false;
            this.modalCaption = "編集";
            // オブジェクトを直接渡すと参照渡しになるので１つずつコピー
            this.modalFreezePeriodsSetting = new AndroidFreezePeriodsSetting();
            this.modalFreezePeriodsSetting.startMonth = this.freezePeriodsSettings[indexs[0]].startMonth;
            this.modalFreezePeriodsSetting.startDay = this.freezePeriodsSettings[indexs[0]].startDay;
            this.modalFreezePeriodsSetting.endMonth = this.freezePeriodsSettings[indexs[0]].endMonth;
            this.modalFreezePeriodsSetting.endDay = this.freezePeriodsSettings[indexs[0]].endDay;
            this.freezePeriodsStartDaySelectList = this.createDaySelectList(this.modalFreezePeriodsSetting.startMonth);
            this.freezePeriodsEndDaySelectList = this.createDaySelectList(this.modalFreezePeriodsSetting.endMonth);

            BootstrapUtil.showModal('modalFreezePeriods');
        }

        /**
         * @brief	削除ボタン
         */
        private onBtnDelFreezePeriods(): void {
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;
            const selectedIndex = refObj.freezePeriodsList.getSelectListIndex();

            for (let i = selectedIndex.length; 0 < i; i--) {
                this.freezePeriodsSettings.splice(selectedIndex[i - 1], 1);
            }

            this.onChangeFreezePeriodsSettings();
        }

        /**
         * @brief	OKボタン押下
         */
        public onModalFreezePeriodsOKButton(): void {

            let error = false;

            // 比較用にコピー
            let settings = cloneDeep(this.freezePeriodsSettings);

            // 編集モードなら自分を排除
            if (!this.modalAddMode) {
                /* eslint @typescript-eslint/no-explicit-any: 0 */
                const refObj: any = this.$refs;
                const indexs = refObj.freezePeriodsList.getSelectListIndex();
                settings.splice(indexs[0], 1);
            }

            // 除外期間のチェック
            this.errorMessageEditFreezePeriods = "";

            // 年を前後に跨いでもうるう年にならない年
            const leapYear = 2002;
            let startDate = new Date(leapYear, this.modalFreezePeriodsSetting.startMonth - 1, this.modalFreezePeriodsSetting.startDay);
            let endDate = new Date(leapYear, this.modalFreezePeriodsSetting.endMonth - 1, this.modalFreezePeriodsSetting.endDay);
            let sufferFreedsPeriods = new Array<string>();

            // 年を跨いだ設定なら終了を１年足しておく
            if (endDate < startDate) {
                endDate.setFullYear(leapYear + 1);
            }

            let afterDate = new Date(startDate);
            afterDate.setDate(afterDate.getDate() + 90);
            if (afterDate <= endDate) {
                this.errorMessageEditFreezePeriods = "除外期間は90日以内で設定してください。";
                error = true;
            }
            else if (0 < settings.length) {
                settings.forEach(x => {

                    // 計算に使用する月日データ
                    let y_start = new Date(startDate);
                    let y_end = new Date(endDate);
                    let x_start = new Date(leapYear, x.startMonth - 1, x.startDay);
                    let x_end = new Date(leapYear, x.endMonth - 1, x.endDay);

                    // 年を跨いだ設定なら終了を１年足しておく
                    if (x_end < x_start) {
                        x_end.setFullYear(leapYear + 1);
                    }

                    // 60日前
                    let x_before = new Date(x_start);
                    x_before.setDate(x_before.getDate() - 60);

                    // 60日後
                    let x_after = new Date(x_end);
                    x_after.setDate(x_after.getDate() + 60);

                    // 年を跨いだかどうかで比較を変える
                    let suffer = false;

                    // 重複判定
                    if ((y_start >= x_start && y_start <= x_end) ||
                        (y_end >= x_start && y_end <= x_end) ||
                        (y_start < x_start && y_end > x_end)) {
                        suffer = true;
                    }
                    else {
                        if (leapYear != y_start.getFullYear() ||
                            leapYear != y_end.getFullYear() ||
                            leapYear != x_before.getFullYear() ||
                            leapYear != x_after.getFullYear()) {
                            // 跨いだ（年数はリセットしておく）
                            y_start.setFullYear(leapYear);
                            y_end.setFullYear(leapYear);
                            x_before.setFullYear(leapYear);
                            x_after.setFullYear(leapYear);

                            if (y_start <= x_after ||
                                x_before <= y_end) {
                                suffer = true;
                            }
                        }
                        else {
                            // 跨いでない
                            if (y_start <= x_before) {
                                // 前にあるとき
                                if (x_before <= y_end) {
                                    suffer = true;
                                }
                            }
                            else if (x_after <= y_end) {
                                // 後にあるとき
                                if (y_start <= x_after) {
                                    suffer = true;
                                }
                            }
                            else {
                                suffer = true;
                            }
                        }
                    }

                    // 被ってたらアウト
                    if (suffer) {
                        sufferFreedsPeriods.push(
                            x.startMonth.toString() + "/" + x.startDay.toString() +
                            "～" +
                            x.endMonth.toString() + "/" + x.endDay.toString());
                    }
                });

                // １つでもあればエラー
                if (0 < sufferFreedsPeriods.length) {
                    error = true;
                    let message =
                        "除外期間が不正です。\r\n<br>" +
                        "以下の除外期間と重なっているか、61日以上の間隔が開いていないため、設定できません。\r\n<br>" +
                        "\r\n<br>";
                    if (1 == sufferFreedsPeriods.length) {
                        message += sufferFreedsPeriods[0];
                    }
                    else {
                        sufferFreedsPeriods.forEach(x => {
                            message += "・" + x + "\r\n<br>";
                        });
                    }
                    MessageUtil.MessageBox(message, null, null, MessageUtil.MB_ICON_WARNING);
                }
            }

            // エラーがあったら更新しない
            if (error) {
                return;
            }

            // 作業用の配列に確保
            if (this.modalAddMode) {
                this.freezePeriodsSettings.push(this.modalFreezePeriodsSetting);
                this.onChangeFreezePeriodsSettings();
                // 追加画面を閉じる
                BootstrapUtil.hideModal('modalFreezePeriods');
                return;
            }

            // 編集データを更新する
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;
            const indexs = refObj.freezePeriodsList.getSelectListIndex();

            this.freezePeriodsSettings[indexs[0]] = this.modalFreezePeriodsSetting;
            this.onChangeFreezePeriodsSettings();

            // 追加画面を閉じる
            BootstrapUtil.hideModal('modalFreezePeriods');
        }

        /**
         * @brief 停止期間のポリシー更新
         */
        private onChangeFreezePeriodsSettings(): void {

            if (undefined == this.policyRef.policy.systemUpdate) {
                return;
            }

            let freezePeriods = new Array<AMAPI_FreezePeriod>();
            this.policyRef.policy.systemUpdate.freezePeriods = freezePeriods;

            this.freezePeriodsSettings.forEach(x => {
                if (undefined != this.policyRef.policy.systemUpdate &&
                    undefined != this.policyRef.policy.systemUpdate.freezePeriods) {
                    let startDate = new AMAPI_Date();
                    let endDate = new AMAPI_Date();
                    startDate.month = x.startMonth;
                    startDate.day = x.startDay;
                    endDate.month = x.endMonth;
                    endDate.day = x.endDay;

                    let freezePeriod = new AMAPI_FreezePeriod();
                    freezePeriod.startDate = startDate;
                    freezePeriod.endDate = endDate;

                    this.policyRef.policy.systemUpdate.freezePeriods.push(freezePeriod);
                }
            });

            this.onChange();
        }
        private updateSystemUpdateFreezePeriods(): void {

            if (undefined == this.policyRef.policy.systemUpdate ||
                undefined == this.policyRef.policy.systemUpdate.freezePeriods) {
                return;
            }

            if (0 < this.policyRef.policy.systemUpdate.freezePeriods.length) {
                this.chkbtn_systemUpdateFreezePeriods = true;

                this.policyRef.policy.systemUpdate.freezePeriods.forEach(x => {
                    let addData = new AndroidFreezePeriodsSetting();
                    if (undefined != x.startDate) {
                        if (undefined != x.startDate.month) {
                            addData.startMonth = x.startDate.month;
                        }
                        if (undefined != x.startDate.day) {
                            addData.startDay = x.startDate.day;
                        }
                    }

                    if (undefined != x.endDate) {
                        if (undefined != x.endDate.month) {
                            addData.endMonth = x.endDate.month;
                        }
                        if (undefined != x.endDate.day) {
                            addData.endDay = x.endDate.day;
                        }
                    }
                    this.freezePeriodsSettings.push(addData);
                })
            }
        }

        /**
         * @brief 選択ボックスの月日の更新
         */
        private onChangeModalStartMonth(): void {

            this.freezePeriodsStartDaySelectList = this.createDaySelectList(this.modalFreezePeriodsSetting.startMonth);

            // はみ出していたらその月の最終日に調整
            if (this.freezePeriodsStartDaySelectList.length < this.modalFreezePeriodsSetting.startDay) {
                this.modalFreezePeriodsSetting.startDay = this.getDaysNumber(this.modalFreezePeriodsSetting.startMonth)
            }
        }
        private onChangeModalEndMonth(): void {

            this.freezePeriodsEndDaySelectList = this.createDaySelectList(this.modalFreezePeriodsSetting.endMonth);

            // はみ出していたらその月の最終日に調整
            if (this.freezePeriodsEndDaySelectList.length < this.modalFreezePeriodsSetting.endDay) {
                this.modalFreezePeriodsSetting.endDay = this.getDaysNumber(this.modalFreezePeriodsSetting.endMonth);
            }
        }

        /**
         * @brief 指定された月の日付けリストを作成
         */
        private createDaySelectList(month: number): Array<SelectBoxItemData> {

            // 日数を取得
            let days = this.getDaysNumber(month);

            // 日付けリストを作成する
            let listData = new Array<SelectBoxItemData>();
            for (let day = 1; day <= days; ++day) {
                let addData = new SelectBoxItemData();
                addData.id = day.toString();
                addData.label = day.toString() + "日";
                listData.push(addData);
            }

            return listData;
        }

        /**
         * @brief 指定された月の日数を取得
         */
        private getDaysNumber(month: number): number {

            // 二四六九士（にしむく侍）
            if (2 == month) {
                return 28;
            }
            else if (
                4 == month ||
                6 == month ||
                9 == month ||
                11 == month) {
                return 30;
            }

            return 31;
        }
    }
</script>

<style>
    @import "../../../assets/css/setting.css";
    @import "../../../assets/css/MobileAndroidCommon.css";
</style>